import { TALK_TO_US } from './tabsLinksData';

export const defaultTabs = [
  {
    href: () => process.env.APP_URL,
    key: 'header:Home'
  },
  {
    href: () => process.env.SELF_SERVICE_URL,
    'data-event': 'self-service-click',
    key: 'header:List your property'
  },
  {
    href: (language = 'en') => `${process.env.APP_URL}${language}/how-it-works`,
    key: 'How it works'
  },
  {
    href: (language = 'en') => TALK_TO_US[language.toUpperCase()],
    'data-event': 'support-click',
    key: 'Contact us'
  },
  {
    href: () => process.env.HELP_URL,
    key: 'Help centre'
  },
  {
    href: () => process.env.AMBASSADOR_URL,
    key: 'Become an Ambassador'
  },
  { separator: true }
];

export const apTabs = [
  {
    href: () => process.env.APP_URL,
    key: 'header:Home'
  },
  {
    href: () => `${process.env.APP_URL}dashboard/profile`,
    key: 'header:Settings'
  },
  {
    href: () => process.env.HOW_IT_WORKS_URL,
    key: 'How it works'
  },
  {
    href: () => process.env.HELP_URL,
    key: 'Help centre'
  }
];

export const guestTabs = [
  {
    href: () => process.env.APP_URL,
    key: 'header:Home'
  },
  {
    href: () => `${process.env.APP_URL}dashboard/profile`,
    key: 'header:Settings'
  },
  {
    href: (language = 'en') => TALK_TO_US[language?.toUpperCase()],
    'data-event': 'support-click',
    key: 'Contact us'
  },
  {
    href: (language = 'en') => `${process.env.APP_URL}${language}/how-it-works`,
    key: 'How it works'
  },
  {
    href: () => process.env.HELP_URL,
    key: 'Help centre'
  },
  {
    href: () => process.env.AMBASSADOR_URL,
    key: 'Become an Ambassador'
  },
  {
    href: () => process.env.INVITE_FRIENDS_URL,
    key: 'Refer your friends'
  }
];
